module.exports = __webpack_public_path__ + "img/3.acc83105.webp";